import { useState } from "react";
import { useSnackbarContext } from "~/SnackbarProvider_v2";
import { Button } from "~/components/Button";
import { DropdownList } from "~/components/DropdownList";
import { NormalModal } from "~/modals/common/NormalModal";
import { Box, Stack } from "./SelectSignRequestDoctorModal.styled";

interface SelectDoctorModalProp {
  doctors: any[];
  signRequestDoctorId: null | number;
  onClose: (value?: any) => void;
}

const SelectSignRequestDoctorModal = ({
  doctors,
  signRequestDoctorId,
  onClose,
}: SelectDoctorModalProp) => {
  const snackbar = useSnackbarContext();
  const [doctor, setDoctor] = useState<null | { id: number; label: string }>(
    doctors.find((f) => f.id === signRequestDoctorId) ?? null
  );

  const handleChangeDoctor = (value: null | { id: number; label: string }) => {
    setDoctor(value);
  };

  const handleSave = () => {
    if (!doctor) {
      return snackbar.alert("전자서명 요청할 의사를 선택하세요.");
    }
    onClose(doctor);
  };

  return (
    <NormalModal
      className="not-border-bottom"
      title="전자서명 요청"
      open={true}
      onClose={() => onClose()}
      footer={
        <Stack flexDirection="row" gap="4px">
          <Button
            styled="outline"
            color="mix"
            size="s"
            onClick={() => onClose()}
          >
            취소
          </Button>
          <Button size="s" onClick={() => handleSave()}>
            요청
          </Button>
        </Stack>
      }
    >
      <Box className="select-doctor-container">
        <span>전자서명 요청할 의사를 선택하세요.</span>
        <Box className="doctor-dropdown">
          <DropdownList
            variant="search"
            placeholder="선택"
            value={doctor}
            options={doctors}
            onChange={handleChangeDoctor}
          />
        </Box>
      </Box>
    </NormalModal>
  );
};

export default SelectSignRequestDoctorModal;
